import Pagination from 'react-bootstrap/Pagination';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../components/Footer';
import { useContext } from "react";
import { currentSearch } from "../contexts/Search";

const MAX_NUM_BTNS = 4

const getMeta = (meta) => {
    const { page, size, total, pages } = meta
    return {
        page: parseInt(page || 0),
        size: parseInt(size || 0),
        total: parseInt(total || 0),
        pages: parseInt(pages || 0)
    }
}

function PaginationComponent() {
    const pageSets = [];
    const {
        results: { meta },
        nextPage,
        prevPage,
        firstPage,
        lastPage,
        setPage
    } = useContext(currentSearch);
    const { page, total, pages } = getMeta(meta);

    for (let i = 0, pSet = 0, pCounter = 0; i < pages; i++) {
        if (!pCounter) {
            pageSets.push([])
        }

        const value = i + 1;
        const label = value;
        const active = label === page;

        if (!pageSets[pSet]) {
            pageSets[pSet] = [];
        }

        pageSets[pSet].push({ label, active, title: `Go to page ${label}`, value })
        pCounter++;
        if (pCounter >= MAX_NUM_BTNS) {
            pCounter = 0;
            pSet++
        }
    }

    const getPaginationItems = () => {
        let currentSetIndex = 0;

        for (let i = 0; i < pageSets.length; i++) {
            const set = pageSets[i];
            if (set?.find(page => page.active)) {
                currentSetIndex = i;
                break;
            }
        }
        const btns = pageSets[currentSetIndex];

        if (currentSetIndex > 0) {
            btns.unshift({ ellipsis: true, title: 'last set of pages', dir: -1 });
        }

        if (currentSetIndex < pageSets.length - 1) {
            btns.push({ ellipsis: true, title: 'Next set of pages', dir: 1 });
        }

        const stepCurrentPageSet = (dir) => {
            const newSetIndex = currentSetIndex + dir;

            if (newSetIndex >= 0 && newSetIndex < pageSets.length) {
                const { value } = pageSets[newSetIndex][0];
                setPage(value)
            }

        }

        return btns.map((item, index) => {
            if (item.ellipsis) {
                return <Pagination.Ellipsis
                    key={index}
                    onClick={e => stepCurrentPageSet(item.dir)}
                    title={item.title}
                />
            } else {
                return <Pagination.Item
                    key={index}
                    onClick={e => setPage(item.label)}
                    active={item.active}
                    title={item.title}>
                    {item.label}
                </Pagination.Item>
            }
        })
    }
    return (
        total <= 1
            ?
            null
            :
            <div className='pagination-component' title={`Page ${page} of ${pages}`}>
                <Pagination>
                    <Pagination.First
                        title='First page'
                        disabled={page <= 1}
                        onClick={firstPage} />
                    <Pagination.Prev
                        title='Previous page'
                        disabled={page <= 1}
                        onClick={prevPage} />
                    {getPaginationItems()}
                    <Pagination.Next
                        title='Next page'
                        disabled={page >= pages}
                        onClick={nextPage} />
                    <Pagination.Last
                        title='Last page'
                        disabled={page >= pages}
                        onClick={lastPage} />
                </Pagination>
            </div>
    )
}

function renderPagination(meta) {
    const pagination = <PaginationComponent className='pagination-control' />;
    const { pages = 0 } = meta || {};
    return (
        pages <= 1 ?
            <Footer />
            :
            <>
                <Row className='pagination-row'>
                    <Col md={{ span: 6, offset: 3 }} className='pagination-container'>
                        {pagination}
                    </Col>
                </Row>
                <Footer />
            </>
    )
}
export { renderPagination }

export default PaginationComponent;